export const preventCancelableDefault = (e) => {
    if (typeof e.cancelable !== 'boolean' || e.cancelable) {
        e.preventDefault();
    }
};
